import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { fetchAllChangeRequests, requestApprovalPageLimit, } from "../../../store/actions/ChangeRequestActions";
import { Box, Tabs, Tab, Button, CircularProgress, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { getSpecialOptions, getTabOptions } from "../../../store/actions/ChangeRequestActions";
import { useHistory } from 'react-router-dom';
import AppBar from "../../../components/AppBar";
import _ from "lodash";
import { getCurrentPageIdentifier } from "../../../utils/appHelper";

const ChangeRequestScreen = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentUser = null } = useSelector(state => state.auth);
  const identifier = getCurrentPageIdentifier();
  let hasWritePermission = false;
  let foundItem = _.find(currentUser?.permisson_matrix || [], { identifier: identifier });
  if (foundItem) {
    hasWritePermission = (foundItem?.actions || []).includes('WRITE');
  }
  const changeRequests = useSelector((state) => state.changeRequest.list);
  const requestsLoading = useSelector((state) => state.changeRequest.loading);
  const maxPage = useSelector((state) => state.changeRequest.maxPage);
  const currentPage = useSelector((state) => state.changeRequest.currentPage);
  const changeRequestsCount = useSelector((state) => state.changeRequestNotification);

  const [activeTab, setActiveTab] = useState(0);
  const [searchText, setSearchText] = useState([]);

  useEffect(() => {
    setSearchText("");
    dispatch(fetchAllChangeRequests({ status: activeTab === 0 ? "pending" : activeTab === 1 ? "approved" : "rejected", searchText: searchText, page: 0 }));
  }, [activeTab]);

  useEffect(() => {
    dispatch(getTabOptions(res1 => {
      dispatch(getSpecialOptions(res2 => { }));
    }));
  }, []);

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePageChange = (e) => {
    dispatch(fetchAllChangeRequests({ status: activeTab === 0 ? "pending" : activeTab === 1 ? "approved" : "rejected", searchText: searchText, page: e }));
  }

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
    dispatch(fetchAllChangeRequests({ status: activeTab === 0 ? "pending" : activeTab === 1 ? "approved" : "rejected", searchText: searchValue, page: 0 }));
  }

  let columns = [
    {
      field: "candidateName",
      flex: 1,
      headerName: "Consultant Name",
      minWidth: 250,
    },
    {
      field: "candidateEmail",
      flex: 1,
      headerName: "Consultant Email",
      minWidth: 250,
    },
    {
      field: "createdByName",
      flex: 1,
      headerName: "Requested by",
      minWidth: 200,
    },
    {
      field: "created_at",
      flex: 1,
      headerName: "Request Date",
      minWidth: 200,
      valueFormatter: params => params.value ? moment.utc(params?.value).local().format("MMM, DD YYYY hh:mm A") : "",
    },
    {
      minWidth: 200,
      height: 150,
      flex: 1,
      headerName: hasWritePermission ? "Review" : "Action",
      renderCell: (params) => {
        const rows = params.row;
        return (
          hasWritePermission ?
            <Tooltip id={'tooltip-review-' + (rows?.candidateEmail || "")} title="Review">
              <Button
                aria-label='review'
                size='small'
                color='primary'
                id={'review-' + (rows?.candidateEmail || "")}
                sx={{ display: 'flex', flexDirection: 'row', gap: 1, textTransform: 'none' }}
                onClick={() => history.push(`/${identifier}/change-request-review/${rows?.root_contract_id}/${rows.id}`)}
              >
                <VisibilityIcon fontSize='small' />
                <Typography variant="subtitle2">Review</Typography>
              </Button>
            </Tooltip>
            :
            <Tooltip id={'tooltip-view-' + (rows?.candidateEmail || "")} title="Review">
              <Button
                aria-label='view'
                size='small'
                color='primary'
                id={'view-' + (rows?.candidateEmail || "")}
                sx={{ display: 'flex', flexDirection: 'row', gap: 1, textTransform: 'none' }}
                onClick={() => history.push(`/${identifier}/change-request-review/${rows?.root_contract_id}/${rows.id}`)}
              >
                <VisibilityIcon fontSize='small' />
                <Typography variant="subtitle2">View</Typography>
              </Button>
            </Tooltip>
        );
      },
    },
  ];

  let approvalColumns = [
    {
      field: "candidateName",
      flex: 1,
      headerName: "Consultant Name",
      minWidth: 250,
    },
    {
      field: "candidateEmail",
      flex: 1,
      headerName: "Consultant Email",
      minWidth: 250,
    },
    {
      field: "createdByName",
      flex: 1,
      headerName: "Requested by",
      minWidth: 200,
    },
    {
      field: "created_at",
      flex: 1,
      headerName: "Request Date",
      minWidth: 200,
      valueFormatter: params => params.value ? moment.utc(params?.value).local().format("MMM, DD YYYY hh:mm A") : "",
    },
    {
      field: "approver_name",
      flex: 1,
      headerName: "Approved by",
      minWidth: 250,
    },
    {
      field: "approved_date",
      flex: 1,
      headerName: "Approval Date",
      minWidth: 250,
      valueFormatter: params => params.value ? moment.utc(params?.value).local().format("MMM, DD YYYY hh:mm A") : "",
    },
    {
      minWidth: 200,
      height: 150,
      flex: 1,
      headerName: "Action",
      renderCell: (params) => {
        const rows = params.row;
        return (
          <Tooltip id={'tooltip-view-' + (rows?.candidateEmail || "")} title="Review">
            <Button
              aria-label='view'
              size='small'
              color='primary'
              id={'view-' + (rows?.candidateEmail || "")}
              sx={{ display: 'flex', flexDirection: 'row', gap: 1, textTransform: 'none' }}
              onClick={() => history.push(`/${identifier}/change-request-review/${rows?.root_contract_id}/${rows.id}`)}
            >
              <VisibilityIcon fontSize='small' />
              <Typography variant="subtitle2">View</Typography>
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  let declineColumns = [
    {
      field: "candidateName",
      flex: 1,
      headerName: "Consultant Name",
      minWidth: 250,
    },
    {
      field: "candidateEmail",
      flex: 1,
      headerName: "Consultant Email",
      minWidth: 250,
    },
    {
      field: "createdByName",
      flex: 1,
      headerName: "Requested by",
      minWidth: 200,
    },
    {
      field: "created_at",
      flex: 1,
      headerName: "Request Date",
      minWidth: 200,
      valueFormatter: params => params.value ? moment.utc(params?.value).local().format("MMM, DD YYYY hh:mm A") : "",
    },
    {
      field: "approver_name",
      flex: 1,
      headerName: "Disapproved by",
      minWidth: 250,
    },
    {
      field: "approved_date",
      flex: 1,
      headerName: "Disapproval Date",
      minWidth: 250,
      valueFormatter: params => params.value ? moment.utc(params?.value).local().format("MMM, DD YYYY hh:mm A") : "",
    },
    {
      minWidth: 200,
      height: 150,
      flex: 1,
      headerName: "Action",
      renderCell: (params) => {
        const rows = params.row;
        return (
          <Tooltip id={'tooltip-view-' + (rows?.candidateEmail || "")} title="Review">
            <Button
              aria-label='view'
              size='small'
              color='primary'
              id={'view-' + (rows?.candidateEmail || "")}
              sx={{ display: 'flex', flexDirection: 'row', gap: 1, textTransform: 'none' }}
              onClick={() => history.push(`/${identifier}/change-request-review/${rows?.root_contract_id}/${rows.id}`)}
            >
              <VisibilityIcon fontSize='small' />
              <Typography variant="subtitle2">View</Typography>
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box sx={{ width: '100%', minHeight: '100svh', bgcolor: '#fff', position: 'relative', p: 2 }}>
      <AppBar appBarTitle="Change Requests" />
      <Box
        sx={{
          background: "#FFFFFF",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 2,
          mt: 2,
          width: "100%",
          position: 'relative',
          pb: 2,
          height: 'calc(100svh - 120px)'
        }}
      >
        <Box sx={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', pl: 2, zIndex: 999 }}>
          <TabNav value={activeTab} handleChange={handleChangeTab} />
          <QuickSearchToolbar value={searchText} onChange={(e) => handleSearch(e.target.value)} clearSearch={() => handleSearch("")} />
        </Box>
        <TabPanel value={activeTab} index={0}>
          <ChangeRequestDataGrid data={changeRequests} columns={columns} maxPage={maxPage} currentPage={currentPage} handlePageChange={handlePageChange} />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <ChangeRequestDataGrid data={changeRequests} columns={approvalColumns} maxPage={maxPage} currentPage={currentPage} handlePageChange={handlePageChange} />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <ChangeRequestDataGrid data={changeRequests} columns={declineColumns} maxPage={maxPage} currentPage={currentPage} handlePageChange={handlePageChange} />
        </TabPanel>
      </Box>
      {requestsLoading || changeRequestsCount?.loading ? <OverlayLoader /> : null}
    </Box>
  );
}

const QuickSearchToolbar = ({ value = "", onChange, clearSearch }) => {

  return (
    <Box display="flex" flexDirection='row' alignItems="center" justifyContent="space-between" pl={1} pr={3} m={2} >
      <TextField
        variant="standard"
        value={value}
        onChange={onChange}
        placeholder="Search"
        InputProps={{
          startAdornment: <SearchIcon color='primary' fontSize="medium" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: value ? 'visible' : 'hidden' }}
              onClick={clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
        sx={{ px: 2, py: 1, width: 300 }}
      />
    </Box>
  );
}

const ChangeRequestDataGrid = ({ data, columns, maxPage, currentPage = 0, handlePageChange }) => {
  return (
    <Box sx={{ width: '100%', height: 'calc(100svh - 210px)' }}>
      <DataGrid
        rows={data}
        columns={columns}
        pagination
        paginationMode='server'
        pageSize={requestApprovalPageLimit}
        rowCount={maxPage}
        page={currentPage}
        rowsPerPageOptions={[requestApprovalPageLimit]}
        onPageChange={handlePageChange}
        density="comfortable"
        disableSelectionOnClick
        disableRowSelectionOnClick
        sx={{
          px: 2,
          border: 0,
          height: "100%",
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "#1089FF",
          },
          "& .MuiDataGrid-cell": {
            margin: 0,
            border: 0,
            width: 300,
          },
          "& .MuiDataGrid-row": {
            margin: 0,
          },
          "& .MuiDataGrid-iconSeparator": {
            display: "none",
          },
        }}
      />
    </Box>
  )
}

const OverlayLoader = () => {
  return (
    <Box sx={{ position: 'absolute', left: 0, top: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.5)', borderRadius: 4 }}>
      <CircularProgress color="primary" />
    </Box>
  )
}

const TabNav = ({ value, handleChange }) => {
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label='change-request-tabs'
    >
      <Tab
        label='Pending'
        {...a11yProps(0)}
      />
      <Tab
        label='Approved'
        {...a11yProps(1)}
      />
      <Tab
        label='Disapproved'
        {...a11yProps(2)}
      />
    </Tabs>
  )
};

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`change-request-tabpanel-${index}`}
      aria-labelledby={`change-request-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ position: 'relative' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `change-request-tab-${index}`,
    "aria-controls": `change-request-tabpanel-${index}`,
  };
}

export default ChangeRequestScreen;
